

import React from 'react';
import xfundingLogo from '../logo/xfunding_logo_64x64.png';
import { Link } from 'react-router-dom';
import './Navbar.css';
import { useAuth } from '../contexts/AuthContext';

function Navbar() {
  const { user, logout } = useAuth();
  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };
  return (
    <nav className="navbar" style={{ position: 'sticky', top: 0, zIndex: 1200 }}>
      <div className="navbar-left">
        <img src={xfundingLogo} alt="XFUNDING Logo" className="navbar-logo-img" />
        <Link to="/" className="navbar-logo">XFUNDING</Link>
        <Link to="/" className="navbar-item">Home</Link>
        <Link to="/challenge-plans" className="navbar-item">Challenge Plans</Link>
        <Link to="/terms" className="navbar-item">Terms of Use</Link>
        <Link to="/faq" className="navbar-item">FAQ</Link>
        <Link to="/contact" className="navbar-item">Contact Us</Link>
      </div>
      <div className="navbar-right" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {user ? (
          <>
            <Link to="/trade" className="navbar-btn" style={{ fontWeight: 600 }}>Dashboard</Link>
            <button className="navbar-btn" onClick={handleLogout} style={{ fontWeight: 600 }}>Logout</button>
          </>
        ) : (
          <>
            <Link to="/signup" className="navbar-btn">Sign Up</Link>
            <Link to="/signin" className="navbar-btn">Sign In</Link>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
